'use client';

import { RefObject } from 'react';

/**
 * Custom hook to smoothly scroll to an element with optional offset
 *
 * @param elementRef Reference to the target HTML element
 * @returns Object with scrollToElement function
 */
const useScrollToElement = (elementRef: RefObject<HTMLElement>) => {
  /**
   * Scrolls the window to the referenced element with a specified offset
   *
   * @param offset Pixels to offset from the element's top position (useful for fixed headers)
   * @default 0
   */
  const scrollToElement = (offset = 0) => {
    if (elementRef.current) {
      const elementPosition = elementRef.current.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return { scrollToElement };
};

export default useScrollToElement;
